import React from 'react'
import { GET_ONE, Link } from 'react-admin'
import { Card, CardContent, CardHeader } from '@material-ui/core'
import dataProviderFactory from '../dataProvider'
import moment from 'moment'
import styled from 'styled-components'
import { map, curry, length, range, addIndex } from 'ramda'
import moment_tz from 'moment-timezone';
// const MonthHeader = styled.div`
//     text-align: center;
// `
// const MonthColumn = styled(Paper)`
//     padding-top: 1rem;
//     padding-bottom: 1rem;
// `

const StyledLink = styled(Link)`
  :link {
    color: #000000;
    text-decoration: underline;
  }
  :visited {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
  :active {
    color: #000000;
  }
`

// const Cell = styled.div({
//     height: '1.5rem',
//     marginRight: '1rem',
// })

// const Block = styled.div({
//     display: 'flex',
//     flexDirection: 'row'
// })

// const Event = styled.div({
//     display: 'flex',
// })

const ColumnLeft = styled.div(props => ({
    display: 'flex',
    flexDirection: 'row',
    width: '11rem',
    backgroundColor: props.color,
    border: '1px solid #ffffff',
    padding: '4px',
}))

const Column = styled.div(props => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: props.color,
    border: '1px solid #ffffff',
    width: '25rem',
    padding: '4px',
}))

const WeekDay = styled.div({
    width: '6.5rem',
    padding: '4px',
})
const Date = styled.div({
    width: '7rem',
    padding: '4px',
})

const Row = styled.div({
    display: 'flex'
})


// const Events = styled.div({
//     display: 'flex',
//     flexDirection: 'columns'
// })


class VehicleHistory extends React.Component {



    async fetchData(id) {
        const dataProvider = await dataProviderFactory('rest')
        const response = await dataProvider(GET_ONE, 'rentals', { id })
        return response.data
    }


    async componentDidMount() {
        moment_tz.tz.setDefault("Europe/Madrid");
        const id = this.props.match.params.id
        await this.updateState(id)
    }


    updateState = async (id) => {
        const data = await this.fetchData(id)
        this.setState({ data })
    }


    sortedDayList = (start, end, nextEventDate) => {
        const add = (day, offset) => day.clone().add(offset, 'days')

        if (end.isSame(nextEventDate, 'day')) {
            return map(curry(add)(start), range(0, end.diff(start, 'days')))

        }
        return map(curry(add)(start), range(0, end.diff(start, 'days') + 1))
    }

    blockForHoldEvent = (hold, nextEventDate) => {

        const start = moment(hold.start_date)
        const end = moment(hold.end_date)

        const days = this.sortedDayList(start, end, nextEventDate)


        return map(day => (
            <Row id={hold.id}>
                <WeekDay>{day.format('dddd')}</WeekDay>
                <Date>{day.format('DD-MM-YYYY')}</Date>
                <ColumnLeft color={'#FF00CC'}>Hold: &nbsp; <StyledLink to={{ pathname: `/holds/${hold.id}` }}>{hold.id}</StyledLink></ColumnLeft>
                <Column color={'#FF00CC'}>{hold.comment}</Column>
            </Row>
        ), days)
    }

    buildLinkTourRental = (rental, title) => {

        return (
            <StyledLink to={{ pathname: `/${(rental.type === 2 ? 'rentals' : 'tours')}/${(rental.type === 2 ? rental.id : rental.booking.tour_id)}` }}>
                {title}
            </StyledLink>
        )
    }



    buildTitleTourRental = (rental, color) => {
        return <ColumnLeft color={(rental.type === 2 ? color : '#CC9999')}> {(rental.type === 2 ? 'Rental' : 'Tour')}: &nbsp; {this.buildLinkTourRental(rental, (rental.type === 2 ? rental.id : rental.booking.tour_id))}</ColumnLeft>
    }

    blockForRental = (rental, nextEventDate) => {
        const start = moment(rental.date_1)
        const end = moment(rental.date_2)

        let days = this.sortedDayList(start, end, nextEventDate)



        return addIndex(map)((day, i) => {

            const color = (() => {
                if ((i === 0 && rental.time_1 === '18:00:00') || (i === length(days) - 1 && rental.time_2 === '10:00:00')) {
                    return '#FFCC66'
                }
                return 'red'
            })()

            const extraInfo = (() => {
                if (i === 0) {
                    return <Column>{rental.km_1} km</Column>
                }
                if (i === length(days) - 1) {
                    return <Column>{rental.km_2} km</Column>
                }

                return null
            })()

            return (
                <Row id={rental.id}>
                    <WeekDay>{day.format('dddd')}</WeekDay>
                    <Date>{day.format('DD-MM-YYYY')}</Date>
                    {this.buildTitleTourRental(rental, color)}
                    <Column color={(rental.type === 2 ? color : '#CC9999')}>{`${rental.booking.r_first_name} ${rental.booking.r_last_name}`}</Column>
                    {extraInfo}
                </Row>
            )
        }, days)

    }

    blockForTransfer = (transfer, nextEventDate) => {
        const start = moment(transfer.transfer_date)
        const end = moment(transfer.setup_date)

        const days = this.sortedDayList(start, end, nextEventDate)


        return map(day => (
            <Row id={transfer.id}>
                <WeekDay>{day.format('dddd')}</WeekDay>
                <Date>{day.format('DD-MM-YYYY')}</Date>
                <ColumnLeft color={'#9966FF'}>Transf: &nbsp; <StyledLink to={{ pathname: `/transfers/${transfer.id}` }}>{transfer.id}</StyledLink></ColumnLeft>
                <Column color={'#9966FF'}>{transfer.TransferItem.notes}</Column>
            </Row>
        ), days)
    }

    daysForEvent = ({ event, type }, nextEventDate) => {
        switch (type) {
            case 'hold':
                return this.blockForHoldEvent(event, nextEventDate)
            case 'transfer':
                return this.blockForTransfer(event, nextEventDate)
            case 'rental':
                return this.blockForRental(event, nextEventDate)
            default:
                return this.blockForRental(event, nextEventDate)
        }

    }

    locationForEvent = ({ event, type }) => {
        switch (type) {
            case 'hold':
                return null
            case 'transfer':
                return event.location_2
            case 'rental':
                return event.location_2
            default:
                return event.location_2
        }
    }

    bikeAtBase = (prevEventDate, nextEventDate, location) => {


        if (nextEventDate === null) { return [] }


        const start = moment(prevEventDate).add(1, 'day')
        const end = moment(nextEventDate).add(-1, 'day')

        const days = this.sortedDayList(start, end)

        return map(curry((vehicle, day) => (
            <Row>
                <WeekDay>{day.format('dddd')}</WeekDay>
                <Date>{day.format('DD-MM-YYYY')}</Date>
                <ColumnLeft color={location.color}>{vehicle.licence_plate} {vehicle.renting ? "®" : ""}</ColumnLeft>
                <Column color={location.color}>{location.location_name}</Column>
            </Row>
        ))(this.state.data), days)




    }

    render() {




        return (
            <Card>
                <CardHeader title={`Rental Details`} />
                <CardContent>
                    <div>Rental Summary:</div>
                    <div> Group rental</div>
                    <div>Pick-up: Lisbon on monday evening, april 29, 2009</div>
                    <div>Drop-off: Lisbon on monday evening, april 29, 2009</div>

                    <div>Rental duration: 8 days</div>
                    <div>Motorcycle: (model) first choice, model (second choice)</div>
                    <div>Daily rate for first choice motorcycle: 129 Euros/day</div>

                    <div>GPS: 8 Euros/day (free with second choice)</div>

                    <div>one way rental: no</div> <div>VIP Insurance: no</div>
                    <div>IMT Rewards: 0 Euros cash discount</div>
                    <div>Rental Cost: </div>
                    <div>First choice of motorcycle: 1.096 Euros. (30% deposit: 328,80 Euros.)</div>
                    <div>Second choice motorcycle: 1.320 Euros. (30% deposit: 396,00 Euros.)</div>

                    <button>process</button>
                    <div>Rider info: </div>
                    <div>Name:</div>
                    <div>email:</div>
                    <div>tel:</div>
                    <div>Address</div>
                    <div>Passport ID: </div>
                    <div>Driver's License: </div>
                    <div>Occupation:</div>
                    <div>Date of Birth:</div>
                    <div>height</div>
                    <div>weight</div>
                    <div>Emergency contact Name:</div>
                    <div>Relationship</div>
                    <div>Emergency tel</div>
                    <div>Languages spoken</div>
                    <div>Years of riding: </div>
                    <div>Riding last year: </div>
                    <div>Average ride distance:</div>
                    <div>Riding Experience:</div>
                    <div>Motorcycle(s) owned:</div>
                    <div>Previous Rentals: </div>
                    <div>Comments: </div>
                    <div>How did you find out about us?:</div>

                </CardContent>

            </Card>
        )
    }

}

export default VehicleHistory


// WEBPACK FOOTER //
// ./src/components/rentalDetails.js